import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/landing/primitives";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useLang();
  const f = t.faq;

  return (
    <section
      id="faq"
      className="relative bg-[#0A0A0A] px-5 py-24 md:px-10 md:py-32"
      data-testid="faq-section"
    >
      <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
        <div>
          <Reveal>
            <Overline>{f.overline}</Overline>
            <h2 className="mt-5 font-display text-5xl font-black leading-[0.95] text-white md:text-6xl">
              {f.title}
            </h2>
            <p className="mt-6 max-w-md text-base text-white/60 md:text-lg">
              {f.subtitle}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {f.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left font-display text-lg font-bold text-white hover:text-brand-green hover:no-underline md:text-xl [&>svg]:text-brand-green">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-white/60 md:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
